export default "__VITE_ASSET__Bd7dDW4Y__"